module.exports = __webpack_public_path__ + "img/Banner Mobile_62.07c753a1.png";